<template>
  <el-dialog
    class="dialog-container"
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    :destroy-on-close="true"
    :close-on-click-modal="false"
    :append-to-body="true"
    @close="closeHandle"
    style="z-index: 10000"
    v-if="dialogVisible"
  >
    <div class="dialog-box">
      <div class="dialog-content">
        <div class="form-list">
          <div class="form-item form-item-half">
            <div class="form-item-title">姓名:</div>
            <div class="form-item-input">
              <el-input v-model="formData.name" placeholder=""></el-input>
            </div>
          </div>
          <div class="form-item form-item-half">
            <div class="form-item-title">学号：</div>
            <div class="form-item-input">
              <el-input v-model="formData.studentCode" placeholder=""></el-input>
            </div>
          </div>
        </div>
        <div class="form-item">
          <div class="form-item-title">任务分工：</div>
          <div class="form-item-input">
            <el-input type="textarea" v-model="formData.task" placeholder=""></el-input>
          </div>
        </div>
      </div>
      <div class="dialog-footer">
        <div class="cancel" @click="closeHandle">取消</div>
        <div class="confirm" @click="submitHandle">确定</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
/*
表格1 编辑弹窗
*/
export default {
  name: "table1Dialog",
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    },
    dialogTitle: {
      type: String,
      default: ""
    },
    visible: {
      type: Boolean,
      default: false
    },
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
    },
    content: {  
      handler(newVal, oldVal) {
        this.formData.name = newVal.name
        this.formData.studentCode = newVal.studentCode
        this.formData.task = newVal.task
      },  
      deep: true // 深度观察 obj 的变化  
    }
  },
  data() {
    return {
      dialogVisible: false,
      formData: {
        name: '',
        studentCode: '',
        task: '',
      },
    }
  },
  methods: {
    closeHandle() {
      this.dialogVisible = false;
      this.$emit('dialogClose');
    },
    submitHandle() {
      if(!this.formData.name) {
        this.$message.error('请输入姓名');
        return false;
      }
      if(!this.formData.studentCode) {
        this.$message.error('请输入学号');
        return false;
      }
      if(!this.formData.task) {
        this.$message.error('请输入任务分工');
        return false;
      }
      this.$emit('submitForm', this.formData);
      this.closeHandle();
    },
  }
}
</script>

<style lang="scss" scoped>
.dialog-container{
  .dialog-box{
    .dialog-content{
      padding: 43rem;

      .form-list{
        display: flex;
        justify-content: space-between;
        margin-bottom: 16rem;
      }

      .form-item{
        width: 100%;

        .form-item-title{
          font-size: 24rem;
          line-height: 44rem;
          color: #999;
          margin-bottom: 6rem;
        }

        .form-item-input{
          /deep/.el-input{
            height: 68rem;
            
            .el-input__inner{
              &:focus {
                border: 1px solid #0FC29A;
              }
            }
          }

          /deep/.el-textarea__inner{
            height: 128rem;
            &:focus {
              border: 1px solid #0FC29A;
            }
          }
        }
      }
      .form-item-half{
        width: 260rem;
        
      }
    }
    .dialog-footer{
      width: 100%;
      display: flex;
      border-top: 1rem solid #E3E3E3;

      >div{
        flex: 1;
        text-align: center;
        font-size: 32rem;
        line-height: 100rem;
        border-right: 1rem solid #E3E3E3;
        cursor: pointer;

        &:last-child{
          border: 0;
        }
      }
      
      .confirm{
        color: #0FC29A;
      }
    }
  }
}
/deep/.el-dialog{
  width: 690rem;
  background: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  bottom: auto;
  transform: translate(-50%, -50%);
  margin: 0 !important;
  min-height: auto;
  border-radius: 20rem;

  .el-dialog__header{
    display: none;
  }
  .el-dialog__body{
    padding: 0;
  }
}
</style>